import { render, staticRenderFns } from "./EditorFileUpload.vue?vue&type=template&id=6bd4264a&scoped=true&"
import script from "./EditorFileUpload.vue?vue&type=script&lang=ts&"
export * from "./EditorFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./EditorFileUpload.vue?vue&type=style&index=0&id=6bd4264a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4264a",
  null
  
)

export default component.exports